// react
import { useState } from 'react'

import styles from './AreaPrefectureList.module.scss'

import { PrefectureInArea } from 'features/prefecture/types/prefecture'

import Link from 'next/link'

// hooks
import { replaceLocale } from 'hooks/common/lang'

interface Props {
  areaName: string
  prefectures?: PrefectureInArea[]
  onSelectAreaName?: (prefecture: PrefectureInArea) => void
  locale: string
  countryCode: string
}

const AreaPrefectureList: React.VFC<Props> = ({
  areaName,
  prefectures,
  locale,
  onSelectAreaName,
  countryCode = 'jpn',
}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  // 言語の修正
  const replacedLocale: string = replaceLocale(locale)

  return (
    <>
      {countryCode === 'twn' ? (
        <>
          {prefectures?.length > 0 && (
            <ul className={styles.prefAreaList}>
              {prefectures.map((prefecture: PrefectureInArea, index: number) => (
                <li className={styles.prefAreaListItem} key={index}>
                  <Link href={`/${replacedLocale}/twn/city/${prefecture.slug}`}>
                    {prefecture.name}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <dl className={styles.prefArea}>
          <dt className={styles.prefAreaTitle}>
            <span className={styles.prefAreaTitleText}>{areaName}</span>
            <span
              className={styles.prefAreaTitleIcon}
              onClick={() => {
                setIsOpen(!isOpen)
              }}
            >
              <img
                className={`${styles.prefAreaArrowImage} ${
                  isOpen ? styles.prefAreaArrowImageActive : ''
                }`}
                src="/arrow_bottom_black.svg"
                alt="arrow_down"
              />
            </span>
          </dt>
          <dd
            className={`${styles.prefAreaListWrap} ${isOpen ? styles.prefAreaListWrapActive : ''}`}
          >
            <ul className={styles.prefAreaList}>
              {prefectures?.length > 0 &&
                prefectures.map((prefecture: PrefectureInArea, index: number) => (
                  <li className={styles.prefAreaListItem} key={index}>
                    <a
                      href={`/${replacedLocale}/jpn/city/${prefecture.slug}`}
                      onClick={(e) => {
                        if (onSelectAreaName) {
                          e.preventDefault()
                          onSelectAreaName(prefecture)
                        }
                      }}
                    >
                      {prefecture.name}
                    </a>
                  </li>
                ))}
            </ul>
          </dd>
        </dl>
      )}
    </>
  )
}

export default AreaPrefectureList
